import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { RouteRecordRaw } from 'vue-router';

import inventoryManagementRouter from '@/router/modules/inventory-management';
import workOrderRouter from '@/router/modules/work-order';
import { useUserStore } from '@/store/';

export const usePermissionStore = defineStore('permission', () => {
  const userStore = useUserStore();
  /**
   * 白名单路由
   */
  const whiteListRouters = ref(['/login']);
  /**
   * 路由列表
   */
  const routers = ref<RouteRecordRaw[]>([]);
  const currentPermissionList = computed(() => userStore.permissions);

  // 判断是否有权限
  const hasPermission = (permissionCode: string | string[]) => {
    if (Array.isArray(permissionCode)) {
      return currentPermissionList.value.some((p) => permissionCode.includes(p.code));
    }
    return currentPermissionList.value.some((p) => p.code === permissionCode);
  };

  // 判断是否具有指定角色
  const hasRole = (role: string): boolean => {
    return userStore.userInfo?.roleName === role;
  };

  // 判断是否具有指定角色
  const isFactoryManager = (): boolean => {
    return userStore.userInfo?.username === '谭希';
  };

  // 判断路由是否有权限访问
  const hasRoutePermission = (meta: any = {}) => {
    // 如果是管理员，可以访问所有路由
    if (isAdmin()) {
      return true;
    }
    // 如果没有配置权限要求，则默认可访问
    if (!meta.role && !meta.permission && !meta.role?.length && !meta.permission?.length) {
      return true;
    }

    const flag = (meta.role && hasRole(meta.role)) || (meta.permission && hasPermission(meta.permission as string[]));

    // 如果配置了角色或权限，满足其中一个即可
    return flag;
  };

  // // 过滤路由
  const filterRoutes = (routes: RouteRecordRaw[]): RouteRecordRaw[] => {
    return routes
      .filter((rt) => hasRoutePermission(rt.meta))
      .map((rt) => {
        const nextRoute = { ...rt };
        if (rt.children?.length) {
          nextRoute.children = filterRoutes(rt.children);
        }
        return nextRoute;
      });
  };

  // 判断是否是管理员
  const isAdmin = () => {
    return userStore.userInfo?.roleName === 'admin';
  };

  // 初始化基础路由
  async function initBaseRoutes() {
    const allRoutes = [...workOrderRouter, ...inventoryManagementRouter];

    // 过滤路由
    routers.value = filterRoutes(allRoutes);
  }

  function resetRoutes() {
    routers.value = [];
  }

  return {
    whiteListRouters,
    routers,
    initBaseRoutes,
    resetRoutes,
    currentPermissionList,
    hasPermission,
    hasRole,
    hasRoutePermission,
    isAdmin,
    isFactoryManager,
  };
});
